export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.80469 2.18555C3.80469 1.63326 4.2524 1.18555 4.80469 1.18555H14.0547C14.607 1.18555 15.0547 1.63326 15.0547 2.18555V9.30093C15.0547 9.85322 14.607 10.3009 14.0547 10.3009H4.80469C4.2524 10.3009 3.80469 9.85322 3.80469 9.30093V2.18555Z"
                stroke="url(#paint0_linear_567_3386)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 5.2998C0.5 4.74752 0.947715 4.2998 1.5 4.2998H17.5C18.0523 4.2998 18.5 4.74752 18.5 5.2998V14.9979C18.5 15.5502 18.0523 15.9979 17.5 15.9979H1.5C0.947716 15.9979 0.5 15.5502 0.5 14.9979V5.2998Z"
                fill="#FDF6E8"
                stroke="url(#paint1_linear_567_3386)"
            />
            <path d="M5 8.02246H5.53548L6.85796 10.5407H6.86607V8.02246H7.34882V11.4407H6.81334L5.49492 8.9273H5.48275V11.4407H5V8.02246Z" fill="#C99452" />
            <path d="M7.94791 8.02246H10.033V8.53951H8.45499V9.43477H9.9154V9.9231H8.45499V10.9237H10.0614V11.4407H7.94791V8.02246Z" fill="#C99452" />
            <path
                d="M10.2192 8.02246H10.7344L11.2577 10.6364H11.2658L11.85 8.02246H12.3692L12.9372 10.6364H12.9453L13.4848 8.02246H14L13.2008 11.4407H12.6856L12.1055 8.82676H12.0974L11.5051 11.4407H10.9818L10.2192 8.02246Z"
                fill="#C99452"
            />
            <defs>
                <linearGradient id="paint0_linear_567_3386" x1="14.4922" y1="1.64132" x2="11.3767" y2="10.7733" gradientUnits="userSpaceOnUse">
                    <stop offset="0.00709733" stopColor="#FBD896" />
                    <stop offset="1" stopColor="#E8BE7D" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_3386" x1="15.125" y1="3.76807" x2="4.18404" y2="16.6104" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#D09D5C" />
                </linearGradient>
            </defs>
        </svg>
    );
}
